import { useEffect, useState } from "react";
import RModal from "../../../../../components/Rsuite/Modal";
import { CustomButton } from "../../../../../components/CustomButton";
import { daysLabels } from "../../../../../constants/daysLabels";
import { dataDays } from "../../../../../constants/dataDays";
import { Spacer } from "../../../../../components/Spacer";
import { Label } from "../../../../../components/Label";
import { CustomInput } from "../../../../../components/CustomInput";
import { CustomCheckPicker } from "../../../../../components/CustomCheckPicker";
import * as S from './styles';
import { useAuth } from "../../../../../hooks/auth";
import { toastSuccess, toastError } from "../../../../../toasts";
import api from "../../../../../services/api";
import { Toggle } from "rsuite";

const EditarCadastrarHorarioBanner = ({ open, handleClose, schedule, banner, setSchedules }) => {
    const { id_empresa } = useAuth();
    const [selecteds, setSelecteds] = useState([]);
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [status, setStatus] = useState(false);

    const validateFields = () => {
        if (!schedule && (!Array.isArray(selecteds) || selecteds.length < 1)) {
            throw new Error('Selecione dias para criar horários');
        }

        if (typeof start !== 'string' || start.length < 5) {
            throw new Error('Selecione a hora de início');
        }

        if (typeof start !== 'string' || end.length < 5) {
            throw new Error('Selecione a hora de termino');
        }
    };

    const createSchedules = async () => {
      try {
          validateFields();

          const form = selecteds.map((day) => ({
              IdEmpresa: id_empresa,
              IdBanner: banner.Id,
              Dia: day,
              Inicio: start,
              Fim: end,
          }));

          const result = await api.post(`horarios-banner/criar`, form)
          setSchedules(state => [...state, ...result.data])
          toastSuccess('Horários foram salvos');
          handleClose();
      } catch (error) {
          const errorMessage = error?.message || 'Não foi possivel criar horários';
          toastError(errorMessage);
      }
    };

    const editSchedule = async () => {
        try {
            validateFields();

            const form = {
                Inicio: start,
                Fim: end,
                Ativo: status
            };

            const result = await api.patch(`horarios-banner/${schedule.Id}`, form);

            setSchedules((state) =>
                state.map((e) => {
                    if (e.Id !== result.data.Id) {
                        return e;
                    }
                    e = result.data;
                    return e;
                }),
            );
            toastSuccess('Horário foi salvo');
            handleClose();
        } catch (error) {
            const errorMessage = error?.message || 'Não foi possivel edirar horário';
            toastError(errorMessage);
        }
    };

    const handleSubmit = async () => {
        if (schedule) {
            editSchedule();
            return;
        }
        createSchedules();
    };

    useEffect(() => {
        if (schedule) {
            setStart(schedule.Inicio);
            setEnd(schedule.Fim);
            setStatus(schedule.Ativo);
        }
    }, [open])

    return (
      <RModal
        open={open}
        onClose={handleClose}
        title={schedule ? "Editar Horário" : "Cadastrar Horário"}
        footer={
          <>
            <CustomButton appearance="default" onClick={handleClose}>
              Cancelar
            </CustomButton>
            <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
          </>
        }
      >
        {!schedule && (
          <S.Column>
            <Label>Dia(s)</Label>
            <CustomCheckPicker
              data={dataDays}
              searchable={false}
              onChange={setSelecteds}
              style={{ width: 350 }}
            />
          </S.Column>
        )}

        {schedule && (
          <S.Column>
              <S.Title>{daysLabels[schedule.Dia]}</S.Title>
          </S.Column>
        )}

        <Spacer y={10} />
        <S.Row>
            <S.Column>
                <Label>Início</Label>
                <CustomInput
                    type="time"
                    onChange={setStart}
                    defaultValue={schedule?.Inicio}
                />
            </S.Column>
            <S.Column>
                <Label>Fim</Label>
                <CustomInput
                    type="time"
                    onChange={setEnd}
                    defaultValue={schedule?.Fim}
                />
            </S.Column>
        </S.Row>
        <Spacer y={10} />
        {schedule && <S.Row>
            <Toggle
                checked={status}
                onChange={() => setStatus(!status)}
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
            />
        </S.Row>}
      </RModal>
    )
}

export default EditarCadastrarHorarioBanner;
